import { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { beforeNavbar, beforeMenu } from '../home/navBar/navBar.action'
import { setCat } from './modal-menu.action'
import { connect } from 'react-redux';

const ModalMenu = (props) => {
    const [cat, setCat] = useState(null)
    const [menuCheck, setMenuCheck] = useState(false)

    useEffect(() => {
        if (props.navBar.navBarAuth) {
            setCat(props.navBar.navBar)
            props.beforeNavbar()
        }
    }, [props.navBar.navBarAuth])

    useEffect(() => {
        if (props.navBar.menuAuth) {
            setMenuCheck(props.navBar.menuAuth)
            props.beforeMenu()
        }
    }, [props.navBar.menuAuth])

    const getCatNFTs = (categoryId) => {
        if (categoryId === 1) {
            activeCat('allitems');
        }
        else {
            activeCat(categoryId);
        }
        props.setCat(categoryId)
    }

    const activeCat = (id) => {
        document.querySelectorAll('.side-nav-lnk').forEach(element => {
            element.classList.remove('active')
        });
        document.querySelector(`#side-lnk-${id}`).classList.add('active');
    }

    const rendMenu = () => {
        if (menuCheck) {
            return (
                <div id="menu" className="modal fade p-0">
                    <div className="modal-dialog dialog-animated">
                        <div className="modal-content h-100">
                            <div className="modal-header" data-dismiss="modal" data-toggle="tooltip" title="Menu">
                                Menu <i className="far fa-times-circle icon-close" />
                            </div>
                            <div className="menu modal-body">
                                <div className="row w-100">
                                    {
                                        cat && cat.length > 0 &&
                                        <ul className="navbar-nav items xxb">
                                            <li id={`side-lnk-allitems`} className={'side-nav-lnk active'}>
                                                <Link to="" onClick={() => getCatNFTs(1)}>All</Link>
                                            </li>
                                            {
                                                cat && cat.length > 0 && cat.map((item, key) => {
                                                    return (
                                                        <li key={key} id={`side-lnk-${item._id}`} className={'side-nav-lnk'}>
                                                            <Link to="" onClick={() => { getCatNFTs(item._id); }}>{item.name}</Link>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }


    return (
        <>
            {
                rendMenu()
            }
        </>
    );
};

const mapStateToProps = state => ({
    error: state.error,
    navBar: state.navBar,
});

export default connect(mapStateToProps, { beforeNavbar, setCat, beforeMenu })(ModalMenu)
